module.exports = "<ng-container>\r\n    <ul class=\"image-list\">\r\n      <div *ngFor=\"let row of rowImages\" style=\"display: flex;\">\r\n        <li *ngFor=\"let image of row\" [style.flex-basis]=\"image.sizePercentage + '%'\" style=\"border: 1px solid black; padding: 0px\">\r\n          <img [src]=\"image.imageURL\" [width]=\"image.width\" [height]=\"image.height\" />\r\n        </li>\r\n      </div>\r\n    </ul>\r\n  </ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/image-resizer-list/image-resizer-list.component.html
// module id = ./src/app/image-resizer-list/image-resizer-list.component.html
// module chunks = main